import { Language } from '@app-types';
import deLocale from './de-DE.json';

export default {
  [Language.De]: deLocale,
};
